import { render } from "./DragAndDropUploader.vue?vue&type=template&id=6e44f3db&scoped=true&ts=true"
import script from "./DragAndDropUploader.vue?vue&type=script&lang=ts"
export * from "./DragAndDropUploader.vue?vue&type=script&lang=ts"

import "./DragAndDropUploader.vue?vue&type=style&index=0&id=6e44f3db&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e44f3db"]])

export default __exports__